import React from 'react'

export const Divider: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: '1rem 0', ...style }} />
)
